import React from "react";
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import ReactHtml from 'raw-html-react';

import { updateQuestion } from '../../actions/';
import TextFiled from '../FillFiled/TextFiled';
import configData from "../../../../Config/CustomStyle.json";
import QuestionTitle from '../QuestionTitle/';
import AiStatsModal from "../../../../Common/AiStatsModal";
import { getToken } from '../../../../../context/auth';

const formatCustomText = (text) => {
    if (!text) return '';
    let formatted = String(text)
        .replace(/\*([^*]+)\*/g, '<strong style="font-weight: 700; color: #0f172a;">$1</strong>')
        .replace(/&([^&]+)&/g, '<em style="font-style: italic; color: #2563eb; font-weight: 600;">$1</em>');
    return formatted;
};

const parseIncrementalJson = (rawJson) => {
    if (!rawJson || typeof rawJson !== 'string') return null;
    let trimmed = rawJson.trim();
    if (!trimmed) return null;

    try {
        return JSON.parse(trimmed);
    } catch (e) {
    }

    let result = { blanks: [] };

    const objectMatches = trimmed.match(/\{[^{}]*?"blankIndex"\s*:\s*\d+[^{}]*?\}/g);
    if (objectMatches) {
        objectMatches.forEach(objStr => {
            try {
                const bObj = JSON.parse(objStr);
                if (bObj && bObj.blankIndex !== undefined) {
                    result.blanks.push(bObj);
                }
            } catch (e) { }
        });
    }

    if (result.blanks.length === 0 || trimmed.lastIndexOf('{') > trimmed.lastIndexOf('}')) {
        const lastOpenIndex = trimmed.lastIndexOf('{');
        if (lastOpenIndex !== -1) {
            const partialStr = trimmed.substring(lastOpenIndex);
            const idxMatch = partialStr.match(/"blankIndex"\s*:\s*(\d+)/);
            const markMatch = partialStr.match(/"mark"\s*:\s*([\d.]+)/);
            const isCorrectMatch = partialStr.match(/"isCorrect"\s*:\s*(true|false)/);
            const expMatch = partialStr.match(/"explanation"\s*:\s*"((?:[^"\\]|\\.)*)/);

            if (idxMatch) {
                const bIdx = parseInt(idxMatch[1]);
                if (!result.blanks.some(b => b.blankIndex === bIdx)) {
                    result.blanks.push({
                        blankIndex: bIdx,
                        mark: markMatch ? parseFloat(markMatch[1]) : undefined,
                        isCorrect: isCorrectMatch ? (isCorrectMatch[1] === 'true') : undefined,
                        explanation: expMatch ? expMatch[1].replace(/\\"/g, '"').replace(/\\n/g, '\n') : undefined
                    });
                }
            }
        }
    }

    return (result.blanks.length > 0) ? result : null;
};

class FillTextView extends React.Component {

    state = {
        CustomStyle: configData.CustomStyle,
        answers: [],
        answersList: [],
        position: {
            x: 0,
            y: 0
        },
        designerContainer: 100,
        timerSeconds: 0,
        tipsList: [],
        currentTipIndex: 0,
        showStats: false,
        aiStats: null,
        fullscreenMessageHtml: null,
        fullscreenMessageQuestion: null,
        mark: {
            type: '',
            userMark: 0,
            isSolved: false
        }
    };

    constructor(props) {
        super(props)
        this.designerContainer = React.createRef();
    }

    handleKeyDown = (e) => {
        if (e.key === "Escape") {
            if (this.state.fullscreenMessageHtml) {
                this.setState({ fullscreenMessageHtml: null, fullscreenMessageQuestion: null });
            }
        }
    };

    componentDidMount() {
        if (this.props.setQuestionDesignerContainer) {
            this.props.setQuestionDesignerContainer(this.designerContainer.current.offsetWidth);
        }
        this.setState({
            designerContainer: this.designerContainer.current.offsetWidth
        });
        window.addEventListener("keydown", this.handleKeyDown);
    }

    componentWillUnmount() {
        if (this.currentAbortController) {
            try { this.currentAbortController.abort(); } catch (e) { }
            this.currentAbortController = null;
        }
        if (this.currentReader) {
            try { this.currentReader.cancel(); } catch (e) { }
            this.currentReader = null;
        }
        if (this.aiTimerInterval) {
            clearInterval(this.aiTimerInterval);
            this.aiTimerInterval = null;
        }
        if (this.firstTokenTimeoutId) {
            clearTimeout(this.firstTokenTimeoutId);
            this.firstTokenTimeoutId = null;
        }
        window.removeEventListener("keydown", this.handleKeyDown);
    }

    static getDerivedStateFromProps(props, state) {
        state.CustomStyle = { ...props.CustomStyle };
        state.answers = props.answers;
        state.categories = props.categories;
        state.QuestionId = props.Id;

        let answerList = [];
        if (state.answers) {
            state.answers.forEach((item) => {
                let pos = null;
                if (state.CustomStyle.answerPosition && Object.keys(state.CustomStyle.answerPosition).length !== 0) {
                    pos = state.CustomStyle.answerPosition.filter(a => a.Id === item.Id)[0];
                }
                answerList.push({
                    ...item,
                    Position: { ...pos }
                });
            });
        }
        state.answers = answerList;

        let fills = [];
        if (props.fills) {
            props.fills.forEach((node) => {
                const hasAnswer = answerList.filter(p => node.AnswerId === p.Id)[0];
                if (hasAnswer) {
                    const hasCategory = state.categories.filter(p => node.CategoryId === p.Id)[0];
                    if (hasCategory) {
                        fills.push(node);
                    }
                }
            });
        }
        state.fills = fills;

        if (props.onEdit === true && props.fills) {
            state.answersList = fills;
        }

        if (props.onEdit === true && props.categories) {
            let trueAnswer = [];
            props.categories.forEach(category => {
                category.CustomStyle?.Answers.forEach(answer => {
                    var result = { ...answer };
                    result.Sort += 1;
                    trueAnswer.push(result);
                });
            });
            state.answersList = trueAnswer;
        }

        if (props.onEdit === true && props.TypeId === 34 && props.Fills) {
            let trueAnswer = [];
            props.categories.forEach(item => {
                const count = item.Name.split("(_)").length - 1;
                for (let index = 1; index <= count; index++) {
                    const listOfTrueAnswersForThisField = props.Fills.filter(p => p.Sort === index && p.CategoryId === item.Id);
                    const listOfTrueAnswersForThisFieldByName = state.answers.filter(p => listOfTrueAnswersForThisField.some(c => c.AnswerId === p.Id))[0];
                    if (listOfTrueAnswersForThisFieldByName) {
                        trueAnswer.push({
                            Id: item.Id,
                            Answer: listOfTrueAnswersForThisFieldByName.Name,
                            Sort: index
                        });
                    }
                }
            });
            state.answersList = trueAnswer;
        }

        if (props.examAnswers) {
            const hasAnswer = props.examAnswers.filter(p => p.Id === props.Id)[0];
            if (hasAnswer) {
                state.answersList = hasAnswer.answers;
                if ((props.TypeId === 33) && hasAnswer.answers && hasAnswer.answers.length > 0 && hasAnswer.answers[0].note) {
                    state.aiStreamAnswer = hasAnswer.answers[0].note;
                    state.mark = {
                        isSolved: true,
                        type: hasAnswer.mark >= props.mark ? 'success' : (hasAnswer.mark > 0 ? 'warning' : 'danger'),
                        userMark: hasAnswer.mark,
                        title: hasAnswer.mark >= props.mark ? props.t('Pages.Lessons.Questions.forms.Options.success.Title') : props.t('Pages.Lessons.Questions.forms.Options.error.Title'),
                        text: hasAnswer.mark >= props.mark ? props.t('Pages.Lessons.Questions.forms.Options.success.Answers') : props.t('Pages.Lessons.Questions.forms.Options.error.Answers')
                    };
                }
            } else if (props.showResult) {
                const { t } = props;
                state.mark = {
                    type: 'danger',
                    userMark: 0,
                    isSolved: true,
                    text: t('Pages.Lessons.Questions.forms.Options.error.NoAnswers'),
                    title: props.isExamQuestion === true ? t('Pages.Lessons.Questions.forms.Options.error.ForExam') : t('Pages.Lessons.Questions.forms.Options.error.Title')
                };
            }
        }
        return state;
    }

    renderAiEvaluationProgress() {
        const { timerSeconds, tipsList, currentTipIndex } = this.state;

        let stageText = "جاري قراءة الإجابة وتحليل التراكيب...";
        let stageIcon = "fas fa-search";
        let progressPercent = 15;

        if (timerSeconds <= 8) {
            stageText = "جاري قراءة الإجابات وتفكيك الجمل...";
            stageIcon = "fas fa-search";
            progressPercent = Math.min(25, 10 + timerSeconds * 2);
        } else if (timerSeconds <= 20) {
            stageText = "فحص القواعد النحوية والصرفية والمنهاج...";
            stageIcon = "fas fa-book";
            progressPercent = Math.min(55, 25 + (timerSeconds - 8) * 2.5);
        } else if (timerSeconds <= 38) {
            stageText = "صياغة الملاحظات والدرجات والتصحيح...";
            stageIcon = "fas fa-pen-fancy";
            progressPercent = Math.min(85, 55 + (timerSeconds - 20) * 1.6);
        } else {
            stageText = "لمسات أخيرة لتدقيق النتيجة وإظهارها...";
            stageIcon = "fas fa-magic";
            progressPercent = Math.min(98, 85 + (timerSeconds - 38) * 0.8);
        }

        const currentTip = (tipsList && tipsList.length > 0)
            ? tipsList[currentTipIndex % tipsList.length]
            : null;

        return (
            <div className="ai-eval-loading-card p-2 p-sm-3 mb-3 w-100" style={{
                background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
                borderRadius: '12px',
                border: '1px solid #cbd5e1',
                boxShadow: '0 4px 15px rgba(0, 0, 0, 0.05)',
                direction: 'rtl',
                boxSizing: 'border-box'
            }}>
                <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2 pb-2" style={{ borderBottom: '1px dashed #cbd5e1' }}>
                    <div className="d-flex align-items-center gap-2" style={{ minWidth: 0 }}>
                        <div className="spinner-border spinner-border-sm text-primary flex-shrink-0" role="status" style={{ width: '1rem', height: '1rem', borderWidth: '0.15em', marginLeft: '6px' }}></div>
                        <span style={{ fontWeight: '700', fontSize: '13px', color: '#0e2c53', wordBreak: 'break-word' }}>
                            جاري التقييم بواسطة الذكاء الاصطناعي... ({timerSeconds} ثانية)
                        </span>
                    </div>
                    <span className="badge" style={{ backgroundColor: '#0e2c53', color: '#fff', fontSize: '11px', padding: '6px 12px', borderRadius: '20px', whiteSpace: 'normal', textAlign: 'right', lineHeight: '1.4' }}>
                        <i className={`${stageIcon} ml-1`}></i> {stageText}
                    </span>
                </div>

                <div className="progress mb-3" style={{ height: '7px', borderRadius: '10px', backgroundColor: '#e2e8f0', overflow: 'hidden' }}>
                    <div className="progress-bar progress-bar-striped progress-bar-animated" style={{
                        width: `${progressPercent}%`,
                        backgroundColor: '#0e2c53',
                        transition: 'width 0.6s ease'
                    }}></div>
                </div>

                {currentTip ? (
                    <div className="tip-card p-2 p-sm-3 text-white position-relative" style={{
                        background: currentTip.Theme || 'linear-gradient(135deg, #4f46e5 0%, #7c3aed 100%)',
                        borderRadius: '10px',
                        boxShadow: '0 4px 12px rgba(0, 0, 0, 0.12)',
                        transition: 'all 0.4s ease'
                    }}>
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-2">
                            <span className="badge" style={{ backgroundColor: currentTip.BadgeBg || 'rgba(255, 255, 255, 0.25)', color: '#fff', fontSize: '11px', padding: '4px 10px', borderRadius: '6px', whiteSpace: 'normal' }}>
                                <i className={currentTip.Icon || "fas fa-lightbulb"} style={{ marginLeft: '5px' }}></i> {currentTip.Category}
                            </span>
                            <span style={{ fontSize: '12px', opacity: 0.95, fontWeight: '700', wordBreak: 'break-word' }}>
                                💡 {currentTip.Title}
                            </span>
                        </div>
                        <div style={{ fontSize: '13px', lineHeight: '1.7', fontWeight: '500', letterSpacing: '0.2px', wordBreak: 'break-word' }}>
                            {currentTip.Content}
                        </div>
                    </div>
                ) : (
                    <div className="tip-card p-2 p-sm-3 text-white" style={{
                        background: 'linear-gradient(135deg, #0e2c53 0%, #1e40af 100%)',
                        borderRadius: '10px'
                    }}>
                        <div className="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-1">
                            <span className="badge" style={{ backgroundColor: 'rgba(255, 255, 255, 0.2)', color: '#fff', fontSize: '11px', padding: '4px 8px', whiteSpace: 'normal' }}>
                                <i className="fas fa-lightbulb ml-1"></i> فائدة اليوم
                            </span>
                            <span style={{ fontSize: '12px', fontWeight: '700' }}>اللغة العربية الفصحى</span>
                        </div>
                        <div style={{ fontSize: '13px', lineHeight: '1.6', wordBreak: 'break-word' }}>
                            هل تعلم أن اللغة العربية هي أثرى لغة بالكلمات والمفردات في العالم دون تكرار!
                        </div>
                    </div>
                )}
            </div>
        );
    }

    renderBranchExplanation(item) {
        if (!this.state.mark || !this.state.mark.isSolved) return null;
        if (this.props.TypeId !== 33) return null;

        let evalObj = this.state.aiEvaluationObj;
        if (!evalObj && this.state.aiStreamAnswer) {
            evalObj = parseIncrementalJson(this.state.aiStreamAnswer);
        }

        const blanksEval = (evalObj && evalObj.blanks) ? evalObj.blanks : [];
        const countBlanksInCat = (item.Name || "").split("(_)").length - 1 || 1;

        let globalIndexOffset = 1;
        const sortedCats = (this.state.categories || []).slice().sort((a, b) => (a.Sort || 0) - (b.Sort || 0));
        for (let c of sortedCats) {
            if (c.Id === item.Id) break;
            const count = (c.Name || "").split("(_)").length - 1 || 1;
            globalIndexOffset += count;
        }

        const totalBlanksCount = (this.state.answersList || []).length || 1;
        const totalQuestionMark = this.props.mark || 10;
        const blankMaxMark = (totalQuestionMark / totalBlanksCount).toFixed(1);

        const catBlanks = [];
        for (let b = 1; b <= countBlanksInCat; b++) {
            const currentGlobalIndex = globalIndexOffset + b - 1;
            const ans = (this.state.answersList || []).find(a => a.Id === item.Id && a.Sort === b) || {
                Id: item.Id, Sort: b, Answer: "", TrueAnswer: ""
            };
            const bEval = blanksEval.find(eb => eb && (eb.blankIndex === currentGlobalIndex)) || blanksEval[currentGlobalIndex - 1];
            catBlanks.push({ ans, bEval, globalIndex: currentGlobalIndex });
        }

        const hasEvaluated = catBlanks.some(cb => {
            const studentAns = (cb.ans && cb.ans.Answer) ? String(cb.ans.Answer).trim() : "";
            if (!studentAns) return true;
            return cb.bEval && (cb.bEval.mark !== undefined || cb.bEval.explanation !== undefined);
        });
        const isAllCorrect = hasEvaluated && catBlanks.every(cb => {
            const studentAns = (cb.ans && cb.ans.Answer) ? String(cb.ans.Answer).trim() : "";
            if (!studentAns) return false;
            const isEv = cb.bEval && (cb.bEval.mark !== undefined || cb.bEval.explanation !== undefined);
            return isEv && (cb.bEval.isCorrect === true || (cb.bEval.mark && cb.bEval.mark > 0));
        });
        const hasAnyIncorrect = hasEvaluated && catBlanks.some(cb => {
            const studentAns = (cb.ans && cb.ans.Answer) ? String(cb.ans.Answer).trim() : "";
            if (!studentAns) return true;
            const isEv = cb.bEval && (cb.bEval.mark !== undefined || cb.bEval.explanation !== undefined);
            return isEv && (cb.bEval.isCorrect === false || (cb.bEval.mark !== undefined && cb.bEval.mark <= 0));
        });

        const outerBg = !hasEvaluated ? "#fdfaf5" : (isAllCorrect ? "#ecfdf5" : (hasAnyIncorrect ? "#fff5f5" : "#fdfaf5"));
        const outerBorderColor = !hasEvaluated ? "#ebd9c5" : (isAllCorrect ? "#a7f3d0" : (hasAnyIncorrect ? "#feb2b2" : "#ebd9c5"));
        const outerAccentColor = !hasEvaluated ? "#0e2c53" : (isAllCorrect ? "#10b981" : (hasAnyIncorrect ? "#e53e3e" : "#0e2c53"));

        return (
            <div
                className="branch-ai-explanation mt-2 p-3 text-right"
                style={{
                    backgroundColor: outerBg,
                    borderRight: `4px solid ${outerAccentColor}`,
                    border: `1px solid ${outerBorderColor}`,
                    borderRadius: "10px",
                    boxShadow: "0 2px 8px rgba(0, 0, 0, 0.04)",
                    transition: "all 0.3s ease",
                    direction: "rtl"
                }}
            >
                {catBlanks.map((cb, bIdx) => {
                    const studentAnswerText = (cb.ans && cb.ans.Answer) ? String(cb.ans.Answer).trim() : "";
                    const isUnanswered = !studentAnswerText;

                    const isEvaluated = !isUnanswered && cb.bEval && (cb.bEval.mark !== undefined || cb.bEval.explanation !== undefined);
                    const isCorrect = isEvaluated && (cb.bEval.isCorrect === true || (cb.bEval.mark && cb.bEval.mark > 0));

                    const itemBg = isUnanswered ? "#fff5f5" : (!isEvaluated ? "#ffffff" : (isCorrect ? "#f0fdf4" : "#fff5f5"));
                    const itemBorderColor = isUnanswered ? "#fed7d7" : (!isEvaluated ? "#e2e8f0" : (isCorrect ? "#bbf7d0" : "#fed7d7"));
                    const itemAccentColor = isUnanswered ? "#e53e3e" : (!isEvaluated ? "#3b82f6" : (isCorrect ? "#10b981" : "#e53e3e"));

                    let formattedMarkDisplay = "-";
                    if (isUnanswered) {
                        formattedMarkDisplay = "0";
                    } else if (isEvaluated && cb.bEval && cb.bEval.mark !== undefined && cb.bEval.mark !== null) {
                        const numMark = Number(cb.bEval.mark);
                        formattedMarkDisplay = !isNaN(numMark) ? (Math.round(numMark * 100) / 100) : String(cb.bEval.mark);
                    }
                    const markBg = isUnanswered ? "#fee2e2" : (isEvaluated ? (isCorrect ? "#d1fae5" : "#fee2e2") : "#f8fafc");
                    const markBorder = isUnanswered ? "#fca5a5" : (isEvaluated ? (isCorrect ? "#a7f3d0" : "#fca5a5") : "#cbd5e1");
                    const markColor = isUnanswered ? "#991b1b" : (isEvaluated ? (isCorrect ? "#065f46" : "#991b1b") : "#0f172a");

                    return (
                        <div key={`b-exp-${cb.globalIndex}`} className="d-flex align-items-start gap-2 mb-3">
                            {countBlanksInCat > 1 && (
                                <span
                                    title={`الفراغ ${bIdx + 1}`}
                                    style={{
                                        backgroundColor: "#0e2c53",
                                        color: "#ffffff",
                                        width: "28px",
                                        height: "28px",
                                        minWidth: "28px",
                                        borderRadius: "50%",
                                        fontSize: "12px",
                                        fontWeight: "800",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        boxShadow: "0 2px 5px rgba(14, 44, 83, 0.2)",
                                        marginTop: "10px",
                                        marginLeft: "10px",
                                        cursor: "pointer"
                                    }}
                                >
                                    {bIdx + 1}
                                </span>
                            )}
                            <div
                                style={{
                                    flex: 1,
                                    backgroundColor: itemBg,
                                    border: `1px solid ${itemBorderColor}`,
                                    borderRadius: "8px",
                                    padding: "12px 14px",
                                    boxShadow: "0 1px 3px rgba(0, 0, 0, 0.03)",
                                    transition: "all 0.3s ease"
                                }}
                            >
                                <div className="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-2 pb-2" style={{ borderBottom: `1px dashed ${isUnanswered ? '#fca5a5' : (isEvaluated ? (isCorrect ? '#a7f3d0' : '#fca5a5') : '#cbd5e1')}`, fontSize: "13px" }}>
                                    <div className="d-flex align-items-center gap-2">
                                        {isUnanswered ? (
                                            <span
                                                style={{
                                                    backgroundColor: "#fee2e2",
                                                    color: "#991b1b",
                                                    border: "1px solid #fca5a5",
                                                    padding: "4px 12px",
                                                    borderRadius: "6px",
                                                    fontSize: "13px",
                                                    fontWeight: "700",
                                                    display: "inline-flex",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <i className="fas fa-times-circle ml-1" style={{ fontSize: "14px", color: "#ef4444" }}></i>
                                                لم يُجب
                                            </span>
                                        ) : isEvaluated ? (
                                            <span
                                                style={{
                                                    backgroundColor: isCorrect ? "#d1fae5" : "#fee2e2",
                                                    color: isCorrect ? "#065f46" : "#991b1b",
                                                    border: isCorrect ? "1px solid #a7f3d0" : "1px solid #fca5a5",
                                                    padding: "4px 12px",
                                                    borderRadius: "6px",
                                                    fontSize: "13px",
                                                    fontWeight: "700",
                                                    display: "inline-flex",
                                                    alignItems: "center"
                                                }}
                                            >
                                                <i className={isCorrect ? "fas fa-check-circle ml-1" : "fas fa-times-circle ml-1"} style={{ fontSize: "14px", color: isCorrect ? "#10b981" : "#ef4444" }}></i>
                                                {studentAnswerText}
                                            </span>
                                        ) : (
                                            <span style={{ backgroundColor: "#f1f5f9", color: "#334155", border: "1px solid #cbd5e1", padding: "4px 12px", borderRadius: "6px", fontSize: "13px", fontWeight: "700", display: "inline-flex", alignItems: "center" }}>
                                                <strong className="text-primary">{studentAnswerText}</strong>
                                            </span>
                                        )}
                                    </div>
                                    <div className="d-flex align-items-center gap-2">
                                        <span style={{ backgroundColor: markBg, border: `1px solid ${markBorder}`, borderRadius: "6px", padding: "4px 10px", fontSize: "12px", fontWeight: "700", color: markColor }}>
                                            العلامة: {formattedMarkDisplay} / {blankMaxMark}
                                        </span>
                                    </div>
                                </div>

                                <div style={{ backgroundColor: isUnanswered ? '#fff9f9' : (isEvaluated ? (isCorrect ? '#f6fbf7' : '#fff9f9') : '#ffffff'), borderRight: `3px solid ${itemAccentColor}`, border: `1px solid ${itemBorderColor}`, borderRadius: "8px", padding: "12px", fontSize: "13px", color: "#475569", lineHeight: "1.6" }}>
                                    {isUnanswered ? (
                                        <>
                                            <strong style={{ color: "#1e293b" }}>التقييم: </strong>
                                            <span style={{ color: "#991b1b", fontWeight: "600" }}>لم تُجب على السؤال</span>
                                        </>
                                    ) : isEvaluated ? (
                                        <>
                                            <strong style={{ color: "#1e293b" }}>التقييم: </strong>
                                            <span dangerouslySetInnerHTML={{ __html: formatCustomText(cb.bEval.explanation) }} />
                                        </>
                                    ) : (
                                        <div>
                                            <div className="mb-2">
                                                <strong style={{ color: "#1e293b" }}>التقييم: </strong>
                                            </div>
                                            {this.renderAiEvaluationProgress()}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    }

    renderCategories() {
        if (this.state.categories) {
            const length = this.state.categories.length;
            let AnswersMargin = 0;
            if (this.state.CustomStyle.questionTypeStyle && this.state.CustomStyle.questionTypeStyle.AnswersMargin) {
                AnswersMargin = this.state.CustomStyle.questionTypeStyle.AnswersMargin;
            }
            return (
                <div className={`row row-cols-1`} style={{
                    height: '100%',
                    position: 'relative'
                }}>
                    {
                        this.state.categories.sort((a, b) => a.Sort - b.Sort).map((item, index) => {
                            if (index + 1 === length) {
                                AnswersMargin = 0;
                            }
                            return (
                                <div className={`col mb-${AnswersMargin}`} key={item.Id}>
                                    {this.renderTextFiled(item)}
                                    {this.renderBranchExplanation(item)}
                                </div>
                            )
                        })
                    }
                </div >
            );
        }
        return "";
    }

    renderControlButton() {
        const { t, solveButton, showResult } = this.props;
        if (solveButton) {
            return (
                <>
                    {showResult !== true ? this.renderMark() : ""}
                    <div className="w-100 mt-3 d-flex justify-content-around">
                        <button className="btn btn-success mx-3" title={t('Pages.Lessons.Questions.forms.Options.CheckAnswer')} onClick={() => this.CheckAnswer()}>
                            <i className="icon fas fa-badge-check"></i> {t('Pages.Lessons.Questions.forms.Options.CheckAnswer')}
                        </button>
                        <button className="btn btn-dark mx-3" title={t('Pages.Lessons.Questions.forms.Options.ResetAnswer')} onClick={() => this.ResetAnswer()}>
                            <i className="icon fas fa-repeat-alt"></i> {t('Pages.Lessons.Questions.forms.Options.ResetAnswer')}
                        </button>
                    </div>
                </>
            );
        } else if (showResult) {
            return (
                <>
                    {this.renderMark()}
                </>
            );
        }
        return "";
    }


    ResetAnswer = () => {
        if (this.currentAbortController) {
            try { this.currentAbortController.abort(); } catch (e) { }
            this.currentAbortController = null;
        }
        if (this.currentReader) {
            try { this.currentReader.cancel(); } catch (e) { }
            this.currentReader = null;
        }
        if (this.aiTimerInterval) {
            clearInterval(this.aiTimerInterval);
            this.aiTimerInterval = null;
        }
        if (this.firstTokenTimeoutId) {
            clearTimeout(this.firstTokenTimeoutId);
            this.firstTokenTimeoutId = null;
        }

        this.state.categories.sort((a, b) => a.Sort - b.Sort).forEach(item => {
            const count = item.Name.split("(_)").length - 1;
            for (let index = 1; index <= count; index++) {
                document.getElementById(`TextFiledAnswer-${item.Id}-${index}`).value = "";
            }
        });
        this.setState({
            answersList: [],
            aiStreamAnswer: '',
            aiEvaluationObj: null,
            aiStats: null,
            showStats: false,
            mark: {
                type: '',
                userMark: 0,
                isSolved: false
            }
        });

    }

    getDifference(a, b) {
        var i = 0;
        var j = 0;
        var result = "";

        while (j < b.length) {
            if (a[i] !== b[j] || i === a.length)
                result += b[j];
            else
                i++;
            j++;
        }
        return result;
    }

    CheckAnswer = async () => {
        const { t, mark, toast, TypeId, Id } = this.props;
        const {
            trueAnswers,
            trueAnswer,
            falseAnswer,
            answersCount,
            answersList } = this.GetAnswerList();

        if (answersCount === 0) {
            let _toastId = toast(t('Processing'), {
                position: "bottom-left",
                autoClose: false
            });
            toast.update(_toastId, {
                render: () => <div><div className="h5"> <i className="icon fal fa-lightbulb-on"></i> {t('Pages.Lessons.Questions.forms.Options.error.NoAnswer.Title')}</div> <div className="h6">{t('Pages.Lessons.Questions.forms.Options.error.NoAnswer.Body')}</div></div>,
                type: toast.TYPE.ERROR,
                position: "bottom-left",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
            });
        } else if (TypeId === 4 || TypeId === 34) {

            if (trueAnswers === trueAnswer) {
                this.setState({
                    answersList,
                    mark: {
                        type: 'success',
                        userMark: mark,
                        isSolved: true,
                        text: t('Pages.Lessons.Questions.forms.Options.success.Answers'),
                        title: t('Pages.Lessons.Questions.forms.Options.success.Title')
                    }
                });
                this.props.playTrueSound();
                this.props.showConfetti();
            } else if (falseAnswer > trueAnswer) {
                this.setState({
                    answersList,
                    mark: {
                        type: 'danger',
                        userMark: (mark * trueAnswer / trueAnswers).toFixed(2),
                        isSolved: true,
                        text: t('Pages.Lessons.Questions.forms.Options.error.Answers'),
                        title: this.props.isExamQuestion === true ? t('Pages.Lessons.Questions.forms.Options.error.ForExam') : t('Pages.Lessons.Questions.forms.Options.error.Title')
                    }
                });
                this.props.playFalseSound();
            } else {
                this.setState({
                    answersList,
                    mark: {
                        type: 'warning',
                        userMark: (mark * trueAnswer / trueAnswers).toFixed(2),
                        isSolved: true,
                        text: t('Pages.Lessons.Questions.forms.Options.error.Answers'),
                        title: this.props.isExamQuestion === true ? t('Pages.Lessons.Questions.forms.Options.error.ForExam') : t('Pages.Lessons.Questions.forms.Options.error.Title')

                    }
                });
                this.props.playFalseSound();
            }
        } else if (TypeId === 33) {

            if (this.currentAbortController) {
                try { this.currentAbortController.abort(); } catch (e) { }
                this.currentAbortController = null;
            }
            if (this.currentReader) {
                try { this.currentReader.cancel(); } catch (e) { }
                this.currentReader = null;
            }
            if (this.aiTimerInterval) {
                clearInterval(this.aiTimerInterval);
                this.aiTimerInterval = null;
            }
            if (this.firstTokenTimeoutId) {
                clearTimeout(this.firstTokenTimeoutId);
                this.firstTokenTimeoutId = null;
            }

            let _toastId = toast(t('Processing'), {
                position: "bottom-left",
                autoClose: false
            });

            this.setState({
                aiStreamAnswer: '',
                aiEvaluationObj: null,
                aiStats: null,
                timerSeconds: 0,
                answersList,
                mark: {
                    isSolved: true,
                    type: 'info',
                    title: t('Pages.Lessons.Questions.forms.Options.ai.title', 'جاري التقييم بواسطة الذكاء الاصطناعي...'),
                    text: t('Pages.Lessons.Questions.forms.Options.ai.text', 'يقوم المساعد الذكي بتقييم إجابتك حالياً، يرجى الانتظار...'),
                    userMark: 0
                }
            });

            const controller = new AbortController();
            this.currentAbortController = controller;
            let hasReceivedFirstToken = false;

            this.firstTokenTimeoutId = setTimeout(() => {
                if (!hasReceivedFirstToken && this.currentAbortController === controller) {
                    controller.abort();
                }
            }, 60000);

            this.aiTimerInterval = setInterval(() => {
                this.setState(prevState => {
                    const nextSec = prevState.timerSeconds + 1;
                    if (!hasReceivedFirstToken && nextSec >= 60) {
                        controller.abort();
                    }
                    let nextTipIdx = prevState.currentTipIndex;
                    if (prevState.tipsList && prevState.tipsList.length > 0 && nextSec % 8 === 0) {
                        nextTipIdx = (prevState.currentTipIndex + 1) % prevState.tipsList.length;
                    }
                    return { timerSeconds: nextSec, currentTipIndex: nextTipIdx };
                });
            }, 1000);

            try {
                const baseUrl = process.env.REACT_APP_BASE_URL || 'https://alarabeyya.com/api';
                const response = await fetch(`${baseUrl}/CheckQuestionAnswer/${Id}`, {
                    method: 'POST',
                    signal: controller.signal,
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': `Bearer ${getToken()}`,
                        'timeZone': Intl.DateTimeFormat().resolvedOptions().timeZone,
                        'TimezoneOffset': - new Date().getTimezoneOffset()
                    },
                    body: JSON.stringify({ Answers: answersList })
                });

                if (!response.ok) {
                    throw new Error(`HTTP error! status: ${response.status}`);
                }

                const reader = response.body.getReader();
                this.currentReader = reader;
                const decoder = new TextDecoder('utf-8');
                let buffer = '';
                let aiStreamAnswer = '';
                let blanks = null;
                let userMark = 0;
                let databaseTimeMs = null;
                let apiTimeMs = null;
                let sendTimeMs = null;
                let responseTimeMs = null;
                let serverTimeMs = null;
                let sendTokens = null;
                let receivedTokens = null;
                let bandwidth = null;
                let sendTokensDetails = null;
                let model = null;
                let price = null;
                let isFromCache = false;

                while (true) {
                    const { value, done } = await reader.read();
                    if (done) break;

                    buffer += decoder.decode(value, { stream: true });
                    const lines = buffer.split('\n');
                    buffer = lines.pop();

                    for (const line of lines) {
                        const trimmed = line.trim();
                        if (!trimmed) continue;

                        let jsonStr = trimmed;
                        if (trimmed.startsWith('data:')) {
                            jsonStr = trimmed.slice(5).trim();
                        }

                        try {
                            const parsed = JSON.parse(jsonStr);

                            if (parsed.Status === 'tips_list' && Array.isArray(parsed.Tips)) {
                                this.setState({ tipsList: parsed.Tips, currentTipIndex: 0 });
                                continue;
                            }

                            if (!hasReceivedFirstToken) {
                                hasReceivedFirstToken = true;
                                if (this.firstTokenTimeoutId) {
                                    clearTimeout(this.firstTokenTimeoutId);
                                    this.firstTokenTimeoutId = null;
                                }
                            }

                            if (parsed.Answer) {
                                aiStreamAnswer += parsed.Answer;
                                const incEval = parseIncrementalJson(aiStreamAnswer);
                                const nextState = { aiStreamAnswer };
                                if (incEval) {
                                    nextState.aiEvaluationObj = incEval;
                                }
                                this.setState(nextState);
                            }
                            if (parsed.Status === 'done') {
                                if (parsed.EvaluationObj) {
                                    this.setState({ aiEvaluationObj: parsed.EvaluationObj });
                                }
                                blanks = parsed.Blanks;
                                userMark = parsed.UserMark;
                                databaseTimeMs = parsed.DatabaseTimeMs;
                                apiTimeMs = parsed.ApiTimeMs;
                                sendTimeMs = parsed.SendTimeMs;
                                responseTimeMs = parsed.ResponseTimeMs;
                                serverTimeMs = parsed.ServerTimeMs;
                                sendTokens = parsed.SendTokens;
                                receivedTokens = parsed.ReceivedTokens;
                                bandwidth = parsed.Bandwidth;
                                sendTokensDetails = parsed.SendTokensDetails ? {
                                    systemInstruction: parsed.SendTokensDetails.SystemInstruction !== undefined ? parsed.SendTokensDetails.SystemInstruction : parsed.SendTokensDetails.systemInstruction,
                                    context: parsed.SendTokensDetails.Context !== undefined ? parsed.SendTokensDetails.Context : parsed.SendTokensDetails.context,
                                    lessonsList: parsed.SendTokensDetails.LessonsList !== undefined ? parsed.SendTokensDetails.LessonsList : parsed.SendTokensDetails.lessonsList,
                                    question: parsed.SendTokensDetails.Question !== undefined ? parsed.SendTokensDetails.Question : parsed.SendTokensDetails.question
                                } : undefined;
                                model = parsed.Model || parsed.model;
                                price = parsed.Price !== undefined ? parsed.Price : parsed.price;
                                isFromCache = parsed.IsFromCache !== undefined ? parsed.IsFromCache : parsed.isFromCache;
                            }
                        } catch (e) {
                            console.warn('Could not parse SSE JSON line', line, e);
                        }
                    }
                }

                if (buffer && buffer.trim()) {
                    const trimmed = buffer.trim();
                    let jsonStr = trimmed;
                    if (trimmed.startsWith('data:')) {
                        jsonStr = trimmed.slice(5).trim();
                    }
                    try {
                        const parsed = JSON.parse(jsonStr);
                        if (!hasReceivedFirstToken) {
                            hasReceivedFirstToken = true;
                            if (this.firstTokenTimeoutId) {
                                clearTimeout(this.firstTokenTimeoutId);
                                this.firstTokenTimeoutId = null;
                            }
                        }
                        if (parsed.Answer) {
                            aiStreamAnswer += parsed.Answer;
                            const incEval = parseIncrementalJson(aiStreamAnswer);
                            const nextState = { aiStreamAnswer };
                            if (incEval) {
                                nextState.aiEvaluationObj = incEval;
                            }
                            this.setState(nextState);
                        }
                        if (parsed.Status === 'done') {
                            if (parsed.EvaluationObj) {
                                this.setState({ aiEvaluationObj: parsed.EvaluationObj });
                            }
                            blanks = parsed.Blanks;
                            userMark = parsed.UserMark;
                            databaseTimeMs = parsed.DatabaseTimeMs;
                            apiTimeMs = parsed.ApiTimeMs;
                            sendTimeMs = parsed.SendTimeMs;
                            responseTimeMs = parsed.ResponseTimeMs;
                            serverTimeMs = parsed.ServerTimeMs;
                            sendTokens = parsed.SendTokens;
                            receivedTokens = parsed.ReceivedTokens;
                            bandwidth = parsed.Bandwidth;
                            sendTokensDetails = parsed.SendTokensDetails ? {
                                systemInstruction: parsed.SendTokensDetails.SystemInstruction !== undefined ? parsed.SendTokensDetails.SystemInstruction : parsed.SendTokensDetails.systemInstruction,
                                context: parsed.SendTokensDetails.Context !== undefined ? parsed.SendTokensDetails.Context : parsed.SendTokensDetails.context,
                                lessonsList: parsed.SendTokensDetails.LessonsList !== undefined ? parsed.SendTokensDetails.LessonsList : parsed.SendTokensDetails.lessonsList,
                                question: parsed.SendTokensDetails.Question !== undefined ? parsed.SendTokensDetails.Question : parsed.SendTokensDetails.question
                            } : undefined;
                            model = parsed.Model || parsed.model;
                            price = parsed.Price !== undefined ? parsed.Price : parsed.price;
                            isFromCache = parsed.IsFromCache !== undefined ? parsed.IsFromCache : parsed.isFromCache;
                        }
                    } catch (e) {
                        console.warn('Could not parse SSE JSON tail buffer', buffer, e);
                    }
                }

                let aiStatsObj = null;
                if (databaseTimeMs !== null || apiTimeMs !== null) {
                    aiStatsObj = {
                        databaseTimeMs,
                        apiTimeMs,
                        sendTimeMs,
                        responseTimeMs,
                        serverTimeMs,
                        sendTokens,
                        receivedTokens,
                        bandwidth,
                        sendTokensDetails,
                        model,
                        price,
                        isFromCache
                    };
                }

                toast.dismiss(_toastId);

                let userMarkFloat = parseFloat(userMark);
                if (isNaN(userMarkFloat)) {
                    userMarkFloat = 0;
                }

                let answersListCorrect = [];
                answersList.forEach((item, index) => {
                    const isBlankCorrect = (blanks && blanks[index] !== undefined) ? blanks[index] : false;
                    answersListCorrect.push({
                        ...item,
                        isTrue: isBlankCorrect,
                        note: index === 0 ? aiStreamAnswer : '',
                        mark: isBlankCorrect ? (mark / trueAnswers) : 0
                    });
                });

                let trueAnswerCount = answersListCorrect.filter(a => a.isTrue).length;
                let falseAnswerCount = trueAnswers - trueAnswerCount;
                let isCorrect = trueAnswerCount === trueAnswers;

                if (isCorrect || Math.abs(userMarkFloat - mark) < 0.05) {
                    userMarkFloat = mark;
                } else {
                    userMarkFloat = Math.round(userMarkFloat * 100) / 100;
                }

                if (this.props.saveExamAnswer) {
                    this.props.saveExamAnswer(this.props.Id, this.props.TypeId, answersListCorrect, {
                        trueResultCount: trueAnswers,
                        trueAnswer: trueAnswerCount,
                        falseAnswer: falseAnswerCount,
                        questionMark: this.props.mark
                    }, userMarkFloat);
                }

                if (isCorrect) {
                    this.setState({
                        answersListCorrect,
                        answersList: answersListCorrect,
                        userMark: userMarkFloat,
                        aiStats: aiStatsObj,
                        mark: {
                            type: 'success',
                            userMark: userMarkFloat,
                            isSolved: true,
                            text: t('Pages.Lessons.Questions.forms.Options.success.Answers'),
                            title: t('Pages.Lessons.Questions.forms.Options.success.Title')
                        }
                    });
                    this.props.playTrueSound();
                    this.props.showConfetti();
                } else if (userMarkFloat > 0) {
                    this.setState({
                        answersListCorrect,
                        answersList: answersListCorrect,
                        userMark: userMarkFloat,
                        aiStats: aiStatsObj,
                        mark: {
                            type: 'warning',
                            userMark: userMarkFloat,
                            isSolved: true,
                            text: t('Pages.Lessons.Questions.forms.Options.error.Answers'),
                            title: this.props.isExamQuestion === true ? t('Pages.Lessons.Questions.forms.Options.error.ForExam') : t('Pages.Lessons.Questions.forms.Options.error.Title')
                        }
                    });
                    this.props.playFalseSound();
                } else {
                    this.setState({
                        answersListCorrect,
                        answersList: answersListCorrect,
                        userMark: userMarkFloat,
                        aiStats: aiStatsObj,
                        mark: {
                            type: 'danger',
                            userMark: userMarkFloat,
                            isSolved: true,
                            text: t('Pages.Lessons.Questions.forms.Options.error.Answers'),
                            title: this.props.isExamQuestion === true ? t('Pages.Lessons.Questions.forms.Options.error.ForExam') : t('Pages.Lessons.Questions.forms.Options.error.Title')
                        }
                    });
                    this.props.playFalseSound();
                }

            } catch (error) {
                if (this.firstTokenTimeoutId) {
                    clearTimeout(this.firstTokenTimeoutId);
                    this.firstTokenTimeoutId = null;
                }
                if (this.aiTimerInterval) {
                    clearInterval(this.aiTimerInterval);
                    this.aiTimerInterval = null;
                }

                const isAbort = error.name === 'AbortError';
                const errorTitle = isAbort ? 'تعذر الاتصال بالمساعد الذكي' : t('Error.NoConnection.Title', 'خطأ في الاتصال');
                const errorBody = isAbort
                    ? 'عذراً، حدثت مشكلة أو تأخير أثناء الاتصال بمزود الذكاء الاصطناعي. يرجى إعادة محاولة الإجابة مرة أخرى.'
                    : (error.message || t('Error.NoConnection.Body'));

                this.setState({
                    mark: {
                        isSolved: true,
                        type: 'danger',
                        userMark: 0,
                        title: errorTitle,
                        text: errorBody
                    }
                });

                toast.update(_toastId, {
                    render: () => <div><div className="h5"> <i className="icon fal fa-clock"></i> {errorTitle}</div> <div className="h6">{errorBody}</div></div>,
                    type: toast.TYPE.ERROR,
                    position: "bottom-left",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: false,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            } finally {
                if (this.firstTokenTimeoutId) {
                    clearTimeout(this.firstTokenTimeoutId);
                    this.firstTokenTimeoutId = null;
                }
                if (this.aiTimerInterval) {
                    clearInterval(this.aiTimerInterval);
                    this.aiTimerInterval = null;
                }
                this.currentReader = null;
                this.currentAbortController = null;
            }
        }
    }

    GetAnswerList = () => {
        let trueAnswer = 0;
        let falseAnswer = 0;
        let trueAnswers = 0;
        let answersCount = 0;
        let answersList = [];
        this.state.categories.sort((a, b) => a.Sort - b.Sort).forEach(item => {
            const CustomStyle = item.CustomStyle;
            const count = item.Name.split("(_)").length - 1;
            trueAnswers += count;
            for (let index = 1; index <= count; index++) {
                let userAnswer = document.getElementById(`TextFiledAnswer-${item.Id}-${index}`).value.trim();
                if (userAnswer) {
                    let newAnswer =
                    {
                        Id: item.Id,
                        Sort: index,
                        Answer: userAnswer,
                        TrueAnswer: "",
                        isTrue: false
                    }

                    if (CustomStyle.Answers) {
                        const answer = CustomStyle.Answers.filter(p => p.Id === item.Id && p.Sort === index - 1)[0];

                        if (answer.IsChecked === true) {
                            userAnswer = userAnswer.replace(/([ًٌٍَُِّْ])/g, "");
                        }
                        if (answer.HamzaIsChecked === true) {
                            userAnswer = userAnswer.replace(/([أإ])/g, "ا");
                        }

                        if (this.props.TypeId === 4) {
                            if (answer && answer.Answer) {
                                if (answer.IsChecked === true) {
                                    userAnswer = userAnswer.replace(/([ًٌٍَُِّْ])/g, "");
                                    answer.Answer = answer.Answer.replace(/([ًٌٍَُِّْ])/g, "");
                                }
                                if (answer.HamzaIsChecked === true) {
                                    userAnswer = userAnswer.replace(/([أإ])/g, "ا");
                                    answer.Answer = answer.Answer.replace(/([أإ])/g, "ا");
                                }

                                newAnswer.TrueAnswer = answer.Answer;

                                let diffrent = this.getDifference(userAnswer, answer.Answer);
                                let rate = (diffrent.length / answer.Answer.length * 100).toFixed(0);

                                if (rate >= 100 || (100 - rate) < answer.Percentage) {
                                    falseAnswer++;
                                } else {
                                    diffrent = this.getDifference(answer.Answer, userAnswer);
                                    rate = (diffrent.length / answer.Answer.length * 100).toFixed(0);
                                    if (rate >= 100 || (100 - rate) < answer.Percentage) {
                                        falseAnswer++;
                                    } else {
                                        trueAnswer++;
                                        newAnswer.isTrue = true;
                                    }
                                }
                            }
                        } else if (this.props.TypeId === 34) {
                            const listOfTrueAnswersForThisField = this.state.fills.filter(p => p.Sort === index && p.CategoryId === item.Id);
                            const listOfTrueAnswersForThisFieldByName = this.state.answers.filter(p => listOfTrueAnswersForThisField.some(c => c.AnswerId === p.Id));

                            let localIsTrue = false;
                            listOfTrueAnswersForThisFieldByName.forEach(itemTrueAnswer => {
                                let itemTrueAnswerName = itemTrueAnswer.Name.trim();
                                if (answer.IsChecked === true) {
                                    itemTrueAnswerName = itemTrueAnswerName.replace(/([ًٌٍَُِّْ])/g, "");
                                }
                                if (answer.HamzaIsChecked === true) {
                                    itemTrueAnswerName = itemTrueAnswerName.replace(/([أإ])/g, "ا");
                                }
                                newAnswer.TrueAnswer = itemTrueAnswerName;

                                let diffrent = this.getDifference(userAnswer, itemTrueAnswerName);
                                let rate = (diffrent.length / itemTrueAnswerName.length * 100).toFixed(0);

                                if (rate >= 100 || (100 - rate) < answer.Percentage) {
                                    return;
                                } else {
                                    diffrent = this.getDifference(itemTrueAnswerName, userAnswer);
                                    rate = (diffrent.length / itemTrueAnswerName.length * 100).toFixed(0);
                                    if (rate >= 100 || (100 - rate) < answer.Percentage) {
                                        return;
                                    } else {
                                        localIsTrue = true;
                                    }
                                }
                            });
                            if (localIsTrue) {
                                trueAnswer++;
                                newAnswer.isTrue = true;
                            } else {
                                falseAnswer++;
                            }
                        }

                        if (this.props.TypeId === 33) {
                            if (answer && answer.Answer) {
                                newAnswer.TrueAnswer = answer.Answer;
                            }
                            newAnswer.model = (answer && answer.model) ? answer.model : "deepseek";
                        }

                        answersCount++;
                    }

                    answersList.push(newAnswer);
                } else {
                    falseAnswer++;
                }
            }
        });

        let userMark = 0;
        const mark = this.props.mark
        if (trueAnswers === trueAnswer) {
            userMark = mark;
        } else {
            userMark = (mark * trueAnswer / trueAnswers).toFixed(2);
        }

        return {
            trueAnswers,
            answersCount,
            trueAnswer,
            falseAnswer,
            answersList,
            userMark
        };
    }

    renderMark() {
        const { t, showResult, TypeId } = this.props;
        if (this.state.mark.isSolved) {
            let evalObj = this.state.aiEvaluationObj;
            if (!evalObj && this.state.aiStreamAnswer) {
                try {
                    evalObj = JSON.parse(this.state.aiStreamAnswer);
                } catch (e) { }
            }

            return (
                <>
                    <div className={`alert mt-4 h5 p-3 alert-${this.state.mark.type}`} role="alert">
                        <h5 className="alert-heading"> <i className="icon fal fa-lightbulb-on"></i>{this.state.mark.title}</h5>
                        {this.state.mark.text}
                        {this.state.mark.type === 'info' && (
                            <div className="mt-3">
                                {this.renderAiEvaluationProgress()}
                            </div>
                        )}
                        {
                            (TypeId === 33 && (evalObj || this.state.aiStreamAnswer)) ? (
                                <div className="bot-bubble-actions-row my-3" style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
                                    {this.state.aiStats && (
                                        <div
                                            className="stats-badge total-time-badge"
                                            onClick={() => this.setState(prev => ({ showStats: !prev.showStats }))}
                                            role="button"
                                            style={{ cursor: 'pointer', gap: '8px' }}
                                        >
                                            <i className="fal fa-robot"></i>
                                            <span style={{ textTransform: 'capitalize', fontWeight: 'bold' }}>
                                                {this.state.aiStats.model || this.state.aiStats.Model || 'deepseek'}
                                            </span>
                                            <span style={{ opacity: 0.3 }}>|</span>
                                            <i className="fal fa-clock"></i>
                                            <span>
                                                {t("Pages.Chatbot.TotalTime") || "وقت الاستجابة الكلي"}: {(((this.state.aiStats.databaseTimeMs || 0) + (this.state.aiStats.apiTimeMs || 0)) / 1000).toFixed(2)} {t("Pages.Chatbot.Sec") || "ثانية"}
                                            </span>
                                        </div>
                                    )}
                                </div>
                            ) : null
                        }
                        <p className="mb-0">{t('Pages.Lessons.Questions.forms.Options.yourMark')} : {this.state.mark.userMark}</p>
                    </div>
                </>
            );
        } else if (showResult) {
            setTimeout(() => {
                const { t, mark } = this.props;
                const {
                    trueAnswers,
                    trueAnswer,
                    falseAnswer
                } = this.GetAnswerList();

                if (trueAnswers === trueAnswer) {
                    this.setState({
                        mark: {
                            type: 'success',
                            userMark: mark,
                            isSolved: true,
                            text: t('Pages.Lessons.Questions.forms.Options.success.Answers'),
                            title: t('Pages.Lessons.Questions.forms.Options.success.Title')
                        }
                    });
                } else if (falseAnswer > trueAnswer) {
                    this.setState({
                        mark: {
                            type: 'danger',
                            userMark: (mark * trueAnswer / trueAnswers).toFixed(2),
                            isSolved: true,
                            text: t('Pages.Lessons.Questions.forms.Options.error.Answers'),
                            title: this.props.isExamQuestion === true ? t('Pages.Lessons.Questions.forms.Options.error.ForExam') : t('Pages.Lessons.Questions.forms.Options.error.Title')
                        }
                    });
                } else {
                    this.setState({
                        mark: {
                            type: 'warning',
                            userMark: (mark * trueAnswer / trueAnswers).toFixed(2),
                            isSolved: true,
                            text: t('Pages.Lessons.Questions.forms.Options.error.Answers'),
                            title: this.props.isExamQuestion === true ? t('Pages.Lessons.Questions.forms.Options.error.ForExam') : t('Pages.Lessons.Questions.forms.Options.error.Title')
                        }
                    });
                }
            }, 500);
        }
        return "";
    }

    renderTextFiled(item) {
        const count = item.Name.split("(_)").length - 1;
        var html = item.Name;
        const CustomStyle = item.CustomStyle;
        for (let index = 0; index < count; index++) {

            let isTrue = "";
            if (this.state.mark.isSolved === true && this.state.mark.type !== 'info') {
                var hasAnswer = this.state.answersList.filter(p => p.Id === item.Id && p.Sort === (index + 1))[0];
                if (hasAnswer && hasAnswer.isTrue) {
                    isTrue = 1;
                } else {
                    isTrue = 0;
                }
            }

            html = html.replace("(_)", `<span version='${this.props.version}' isTrue='${isTrue}'  Sort='${index + 1}' data-react-component="TextFiled"></span>`);
        }
        return <ReactHtml
            html={html}
            handleAnswerChange={this.handleAnswerChange}
            SoundIconType={this.state.CustomStyle.questionTypeStyle.AnswersSelectType}
            SoundIconClass={this.state.CustomStyle.questionTypeStyle.AnswersSelectClass}
            CustomStyle={CustomStyle}
            componentMap={{ TextFiled }}
            CategoryId={item.Id}
            QuestionId={this.state.QuestionId}
            answersList={this.state.answersList} />;
    }

    saveExamAnswer() {
        if (this.props.saveExamAnswer) {
            setTimeout(() => {
                const {
                    trueAnswers,
                    trueAnswer,
                    falseAnswer,
                    answersList,
                    userMark } = this.GetAnswerList();
                this.props.saveExamAnswer(this.props.Id, this.props.TypeId, answersList, {
                    trueResultCount: trueAnswers,
                    trueAnswer,
                    falseAnswer,
                    questionMark: this.props.mark
                }, userMark);
            }, 500);
        }
    }

    handleAnswerChange = () => {
        this.saveExamAnswer();
    }

    render() {
        const { title, mark, index, Id, onEdit, t } = this.props;
        const statsStyles = `
            .stats-badge.total-time-badge {
                cursor: pointer;
                user-select: none;
                display: inline-flex;
                align-items: center;
                gap: 5px;
                background: rgba(146, 39, 143, 0.03);
                border: 1px solid rgba(146, 39, 143, 0.1);
                color: #92278f;
                font-weight: 500;
                transition: all 0.2s ease;
                padding: 5px 10px;
                border-radius: 8px;
                font-size: 12px;
                font-family: "Droid Arabic Naskh", sans-serif;
            }
            .stats-badge.total-time-badge:hover {
                background: rgba(146, 39, 143, 0.07);
                border-color: rgba(146, 39, 143, 0.3);
                transform: translateY(-0.5px);
            }
            .fullscreen-modal-overlay {
                position: fixed;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                background-color: rgba(14, 44, 83, 0.65);
                backdrop-filter: blur(8px);
                -webkit-backdrop-filter: blur(8px);
                z-index: 10000;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 30px;
            }
            .fullscreen-modal-card {
                background: rgba(255, 255, 255, 0.95);
                border: 1px solid rgba(235, 217, 197, 0.6);
                border-radius: 24px;
                width: 100%;
                max-width: 1000px;
                height: 90vh;
                display: flex;
                flex-direction: column;
                box-shadow: 0 30px 60px rgba(14, 44, 83, 0.25);
                overflow: hidden;
            }
            .fullscreen-modal-header {
                padding: 20px 30px;
                border-bottom: 1px solid rgba(235, 217, 197, 0.5);
                display: flex;
                align-items: center;
                justify-content: space-between;
                background-color: #fdfaf5;
            }
            .fullscreen-modal-title {
                margin: 0;
                font-size: 20px;
                font-weight: 700;
                color: #0e2c53;
                display: flex;
                align-items: center;
                gap: 10px;
                font-family: "Droid Arabic Naskh", sans-serif;
            }
            .fullscreen-modal-close-btn {
                background: none;
                border: none;
                color: #ff5200;
                font-size: 24px;
                cursor: pointer;
                display: flex;
                align-items: center;
                justify-content: center;
                transition: all 0.2s ease;
                width: 40px;
                height: 40px;
                border-radius: 50%;
            }
            .fullscreen-modal-close-btn:hover {
                background-color: rgba(255, 82, 0, 0.1);
                transform: scale(1.1);
            }
            .fullscreen-modal-body {
                flex: 1;
                padding: 40px;
                overflow-y: auto;
                text-align: right;
                direction: rtl;
            }
            .bot-bubble-actions-row {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 12px;
                margin-top: 8px;
                width: 100%;
            }
            .bot-bubble-actions {
                display: flex;
                flex-direction: row;
                align-items: center;
                gap: 8px;
            }
            .fullscreen-expand-btn, .bubble-download-btn {
                background: #ffffff;
                border: 1px solid rgba(235, 217, 197, 0.6);
                color: #8c857b;
                width: 30px;
                height: 30px;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                cursor: pointer;
                transition: all 0.2s ease;
                box-shadow: 0 2px 5px rgba(14, 44, 83, 0.05);
                outline: none;
                font-size: 13px;
            }
            .fullscreen-expand-btn:hover {
                background: #ffffff;
                color: #92278f;
                border-color: #92278f;
                box-shadow: 0 4px 12px rgba(146, 39, 143, 0.15);
                transform: scale(1.05);
            }
            .bubble-download-btn:hover {
                background: #ffffff;
                color: #8dc63f;
                border-color: #8dc63f;
                box-shadow: 0 4px 12px rgba(141, 198, 63, 0.15);
                transform: scale(1.05);
            }
            .fullscreen-modal-download-btn {
                background: linear-gradient(135deg, #8dc63f 0%, #7bb32d 100%);
                color: #ffffff !important;
                box-shadow: 0 4px 12px rgba(141, 198, 63, 0.25);
                border: none;
                display: inline-flex;
                align-items: center;
                gap: 8px;
                padding: 8px 16px;
                border-radius: 10px;
                font-size: 13px;
                font-weight: 700;
                cursor: pointer;
                transition: all 0.25s ease;
            }
            .fullscreen-modal-download-btn:hover {
                background: linear-gradient(135deg, #7bb32d 0%, #689823 100%);
                box-shadow: 0 6px 16px rgba(141, 198, 63, 0.35);
                transform: translateY(-1px);
            }
        `;
        const SizeView = this.props.SizeView ? this.props.SizeView : 100;

        let style = {
            minHeight: `${this.state.CustomStyle.questionStyle.height}px`,
            width: `${this.state.CustomStyle.questionStyle.width}%`,
            maxWidth: '100%',
            paddingLeft: `${this.state.CustomStyle.questionStyle.PaddingLeft}px`,
            paddingTop: `${this.state.CustomStyle.questionStyle.PaddingTop}px`,
            paddingRight: `${this.state.CustomStyle.questionStyle.PaddingRight}px`,
            paddingBottom: `${this.state.CustomStyle.questionStyle.PaddingBottom}px`,

            borderColor: this.state.CustomStyle.questionStyle.BorderColor !== 'transparent' ? this.state.CustomStyle.questionStyle.BorderColor : "",
            borderStyle: `${this.state.CustomStyle.questionStyle.BorderStyle}`,
            borderLeftWidth: `${this.state.CustomStyle.questionStyle.BorderWidthLeft}px`,
            borderRightWidth: `${this.state.CustomStyle.questionStyle.BorderWidthRight}px`,
            borderTopWidth: `${this.state.CustomStyle.questionStyle.BorderWidthTop}px`,
            borderBottomWidth: `${this.state.CustomStyle.questionStyle.BorderWidthBottom}px`,
            borderRadius: `${this.state.CustomStyle.questionStyle.BorderRadiusTop}${this.state.CustomStyle.questionStyle.BorderRadiusUnit} ${this.state.CustomStyle.questionStyle.BorderRadiusRight}${this.state.CustomStyle.questionStyle.BorderRadiusUnit} ${this.state.CustomStyle.questionStyle.BorderRadiusBottom}${this.state.CustomStyle.questionStyle.BorderRadiusUnit} ${this.state.CustomStyle.questionStyle.BorderRadiusLeft}${this.state.CustomStyle.questionStyle.BorderRadiusUnit}`,
            boxShadow: `${this.state.CustomStyle.questionStyle.ShadowPositionX}px ${this.state.CustomStyle.questionStyle.ShadowPositionY}px ${this.state.CustomStyle.questionStyle.ShadowRadius}px 0px ${this.state.CustomStyle.questionStyle.shadowColor}`,
        };

        let styleBackground = {
            height: `100%`,
            marginLeft: `-${this.state.CustomStyle.questionStyle.PaddingLeft}px`,
            marginTop: `-${this.state.CustomStyle.questionStyle.PaddingTop}px`,
            marginRight: `-${this.state.CustomStyle.questionStyle.PaddingRight}px`,
            marginBottom: `-${this.state.CustomStyle.questionStyle.PaddingBottom}px`,
            opacity: `${this.state.CustomStyle.questionStyle.Opacity}%`,
            backgroundColor: this.state.CustomStyle.questionStyle.backgroundColor !== 'transparent' ? this.state.CustomStyle.questionStyle.backgroundColor : "",
            backgroundImage: this.state.CustomStyle.questionStyle.backgroundImage !== '' ? `url('${this.state.CustomStyle.questionStyle.backgroundImage}')` : "",
            backgroundPositionX: `${this.state.CustomStyle.questionStyle.BgPositionX}%`,
            backgroundPositionY: `${this.state.CustomStyle.questionStyle.BgPositionY}%`,
            backgroundSize: `${this.state.CustomStyle.questionStyle.BgSize}`,
            backgroundRepeat: `${this.state.CustomStyle.questionStyle.BgRepeat}`,
            backgroundAttachment: `${this.state.CustomStyle.questionStyle.BgAttachment}`,
        };

        if (this.state.CustomStyle.questionTypeStyle.AnswerOrder === 'absolute') {
            style = { ...style, height: `${this.state.CustomStyle.questionStyle.height}px` };
        }

        let align = "x";
        if (this.state.CustomStyle.questionTypeStyle.AnswersAlign) {
            if (this.state.CustomStyle.questionTypeStyle.AnswersAlign === 'left') {
                align = "l";
            } else if (this.state.CustomStyle.questionTypeStyle.AnswersAlign === 'right') {
                align = "r";
            }
        }

        return (
            <div className={`w-${SizeView} mb-3 mx-auto`}>
                <style dangerouslySetInnerHTML={{ __html: statsStyles }} />
                <div className="bg-white w-100 p-3 form-group position-relative">
                    <QuestionTitle mark={mark} onEdit={onEdit} index={index} title={title} ResetAnswer={this.ResetAnswer} isExamQuestion={this.props.isExamQuestion} updateVersion={this.props.updateVersion}></QuestionTitle>
                    <div className="w-100" ref={this.designerContainer}>
                        <div className={`m${align}-auto position-relative overflow-hidden`} style={style} >
                            <div className="w-100 position-absolute" style={styleBackground} id={`SelectDesignerPreview_${Id}`} > </div>
                            <style dangerouslySetInnerHTML={{ __html: `#SelectDesignerPreview_${Id}{${this.state.CustomStyle.questionStyle.Custom} }` }}></style>
                            {this.renderCategories()}
                        </div>
                        {this.renderControlButton()}
                    </div>
                </div>
                <AiStatsModal
                    isOpen={this.state.showStats}
                    onClose={() => this.setState({ showStats: false })}
                    stats={this.state.aiStats}
                    t={t}
                />
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        question: state.questions
    };
};

export default connect(mapStateToProps, { updateQuestion })(withTranslation('common')(FillTextView));